import { object, string } from 'yup';

import { YUP_ERRORS_MESSAGES } from '@shared/constants';

export const referralAssignSchema = object().shape({
  referralTelegramNickname: string().required(YUP_ERRORS_MESSAGES.REQUIRED),
});
